// PCG doesn't have exact equivalency with
// pokeapi. This means that certain pokémon
// won't have the exact same id
// This function aims to parse those edge cases
// It might be a good idea to migrate everything
// to PCG in the future, for consistency
const pokeApiIdByOrder = (pokemon) => {
  switch (pokemon.order) {
    // Vivillon
    case 666:
      return 666;
    // galarian-rapidash
    case 78:
      if (pokemon.pokedexId === 78) {
        return pokemon.pokedexId;
      }

      return 10163;
    // galarian-articuno
    case 144:
      if (pokemon.pokedexId === 144) {
        return pokemon.pokedexId;
      }

      return 10169;
    // marowak-alola-sinister
    case 105:
      if (pokemon.pokedexId === 105) {
        return pokemon.pokedexId;
      }

      return 10115;

    // cosmog-sinister
    case 789:
      return 789;

    // palossand-sinister
    case 770:
      return 770;

    // rockruff-sinister
    case 744:
      return 744;

    // kartana-sinister
    case 798:
      return 798;

    // oricorio
    case 741:
      // oricorio-baile
      if (pokemon.pokedexId === 741) {
        return 741;
      }

      // oricorio-sensu
      if (pokemon.pokedexId === 10137) {
        return 10125;
      }

      return pokemon.pokedexId;

    // lycanroc
    case 745:
      if (pokemon.pokedexId === 745) {
        return pokemon.pokedexId;
      }

      // lycanroc-midnight
      if (pokemon.pokedexId === 10116) {
        return 10126;
      }

      // lycanroc-dusk
      if (pokemon.pokedexId === 10117) {
        return 10152;
      }

      return pokemon.pokedexId;

    // alcremie
    case 869: 

      // alcremie-rainbow
      return 869;

    // exeggutor-alola
    // marowak-alola
    // raichu-alola
    // sandshrew-alola
    // sandslash-alola
    // vulpix-alola
    // ninetales-alola
    // diglett-alola
    // rotom-heat
    // rotom-wash
    // rotom-frost
    // rotom-fan
    // rotom-mow
    default:
      return pokemon.pokedexId;
  }
};

export { pokeApiIdByOrder };
